import React, { useState } from 'react';
import Image from 'next/image';

const ImageSlider = props => {
  const [active, setActive] = useState(1);
  const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const changeActive = e => {
    e.target.parentNode.querySelectorAll('.option').forEach(el => {
      el.classList.remove('active');
    });
    e.target.classList.add('active');
  };
  const changeActiveFromLabel = e => {
    e.target.parentNode.parentNode.parentNode.parentNode.parentNode.querySelectorAll('.option').forEach(el => {
      el.classList.remove('active');
    });
    e.target.parentNode.parentNode.parentNode.parentNode.classList.add('active');
  };
  return (
    <>
      <div className="options">
        {props.slides &&
          props.slides.map((s, i) => {
            return (
              <div
                className={`option ${active === i ? 'active' : ''}`}
                onClick={e => changeActive(e)}
                style={{ background: `url('${s.image}')` }}
                key={uuidv4()}
                data-id={i}
              >
                <div className="shadow" />
                <div className="label">
                  <div className="icon" onClick={e => changeActiveFromLabel(e)}>
                    <Image src={s.icon} width={53} height={53} alt={'icon'} />
                  </div>
                  <div className="info">
                    <div className="main">{s.title}</div>
                    <div className="sub">{s.subtitle}</div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <style jsx global>
        {`
          .options .option::after {
            content: '';
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background-color: #000000d9;
            filter: brightness(150%);

            // filter: brightness(0) invert(1);
            // filter: sepia(1) saturate(5) brightness(0.5) hue-rotate(135deg);
            // filter: invert(100%);
          }
          .options .option.active::after {
            content: unset;
          }

          .options {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            overflow: hidden;
            width: 100%;
            height: 411px;
          }

          .options .option {
            position: relative;
            overflow: hidden;
            min-width: 71px;
            margin: 10px;
            cursor: pointer;
            border-radius: 5px;
            transition: all 1s linear;
          }
          .options .option:first-child {
            margin-left: 0px;
          }
          .options .option.active {
            flex-grow: 10000;
            filter: none;
          }
          .options .option.active .shadow {
            box-shadow:
              inset 0 -120px 120px -120px black,
              inset 0 -120px 120px -100px black;
          }
          .options .option.active .label {
            bottom: 20px;
            left: 30px;
          }
          .options .option.active .label .info > div {
            left: 0px;
            opacity: 1;
          }

          .options .option:not(.active) .shadow {
            bottom: -40px;
            box-shadow:
              inset 0 -120px 0px -120px black,
              inset 0 -120px 0px -100px black;
          }
          .options .option:not(.active) .label {
            bottom: 10px;
            left: 10px;
          }
          .options .option:not(.active) .label .info > div {
            left: 20px;
            opacity: 0;
          }
          .options .option .shadow {
            position: absolute;
            bottom: 0px;
            left: 0px;
            right: 0px;
            height: 120px;
          }
          .options .option .label {
            display: flex;
            position: absolute;
            right: 0px;
            height: 40px;
          }
          .options .option .label .icon {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            min-width: 50px;
            max-width: 40px;
            height: 40px;
            border-radius: 5px;
            position: relative;
            z-index: 100;
          }
          .options .option .label .info {
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-left: 10px;
            color: white;
            white-space: pre;
          }
          .options .option .label .info > div {
            position: relative;
            transition:
              0.5s linear,
              opacity 0.5s linear;
          }
          .options .option .label .info .main {
            font-weight: bold;
            font-size: 1.2rem;
          }
          .options .option .label .info .sub {
            transition-delay: 0.1s;
          }
          @media screen and (max-width: 1000px) {
            .options {
              flex-direction: column;
              height: auto;
            }
            .option {
              min-height: 71px;
            }
            .options .option.active {
              height: 196px;
              -webkit-transition: 2s linear;
              transition: 2s linear;
              background-size: cover !important;
              background-position: center !important;
              background-repeat: no-repeat !important;
            }
            .options .option .label .info .main {
              font-size: 18px;
            }
            .options .option.active .label {
              left: 10px;
            }
            .options .option:not(.active) .label {
              bottom: 15px;
            }
            .options .option:first-child,
            .options .option {
              margin-left: 20px;
              margin-right: 20px;
            }
          }
        `}
      </style>
    </>
  );
};
export default ImageSlider;
